module.exports = __webpack_public_path__ + "static/media/fj80-landcruiser-2.a83e36f0.jpg";